export const NEW_COMMERCIAL_CONTACT = 'newCommercialContact';
export const DELETE_COMMERCIAL_CONTACT = 'delete-commercial-contact';
